import type { FunctionComponent, ReactNode } from 'react';

import { verify_subscription } from '../../utils';
import Badge from '../generic/Badge/Badge';
import Flex from '../generic/Flex';
import PaidFeatureGate from '../generic/Gates/PaidFeatureGate';
import Text from '../generic/Text';

type Props = {
  title: string;
  description: ReactNode;
  emailDeliveryMessage?: string;
  showPreviewTag?: boolean;
  requiredTier?: 'premium' | 'enterprise';
};

/**
 * The Card for queueing a report from the Global Reports page. The children of this card should be the
 * buttons/dropdowns for submitting the action.
 */
const DashboardReportCard: FunctionComponent<Props> = ({
  children,
  title,
  emailDeliveryMessage,
  description,
  showPreviewTag,
  requiredTier = 'premium',
}) => {
  return (
    <PaidFeatureGate
      isRestricted={!verify_subscription(requiredTier)}
      planToShow={requiredTier === 'enterprise' ? 'Enterprise' : undefined}
    >
      <div className="panel">
        <div className="reportHeader">
          <Text.H1>
            <Flex justify="left" align="center" gap={8}>
              {title}
              {showPreviewTag && (
                <Badge outline color="light-gray">
                  PREVIEW
                </Badge>
              )}
            </Flex>
          </Text.H1>
        </div>
        <p className="reportDescription">
          {description}
          <em>{emailDeliveryMessage}</em>
        </p>
        {children}
      </div>
    </PaidFeatureGate>
  );
};

export default DashboardReportCard;
